import { Container, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Severe from "../Assets/Severe.svg";
import Normal from "../Assets/Normal.svg";
import Blue from "../Assets/Blue.svg";

function ColorLabel() {
  return (
    <Container fluid className="Forecast">
      <Row>
        <h5>Impact Class</h5>
      </Row>
      <Card className="ColorLabel_card">
        <Card.Body className="ColorLabel_body">
          <div>
            <table>
              <tr className="ColorLabel_row">
                <td>
                  <img
                    src={Severe}
                    className="ColorLabel_box"
                    alt="abc"
                    width="20px"
                    height="20px"
                  />
                </td>
                <td>Probable Heatwave Alert</td>
              </tr>
              <tr>
                <td>
                  <img
                    src={Normal}
                    className="ColorLabel_box"
                    alt=""
                    width="20px"
                    height="20px"
                  />
                </td>
                <td>Heat Watch</td>
              </tr>
              <tr>
                <td>
                  <img
                    src={Blue}
                    className="ColorLabel_box"
                    alt=""
                    width="20px"
                    height="20px"
                  />
                </td>
                <td>No Alert</td>
              </tr>
            </table>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ColorLabel;
